import * as React from "react";
import { Route } from "react-router";

import { Container } from "../../../Container";
import { VehicleGeopositionStore } from "../Vehicle/flux/VehicleGeopositionStore";
import { vehicleGeoposition } from "../../../routes";
import { VehicleGoogleMap } from "./Map";

interface Props
{
    vehicleGeopositionStore: VehicleGeopositionStore;
}

export class VehicleMapRoute extends React.Component<Props, any>
{
    render()
    {
        const { vehicleGeopositionStore } = this.props;
        return (
            <Route path={vehicleGeoposition} render={() => (
                <div style={{flex: 1}}>
                    <Container store={vehicleGeopositionStore}>
                        <VehicleGoogleMap defaultZoom={10} Vehicles={null} />
                    </Container>
                </div>
            )} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/VehicleMap/VehicleMapRoute.tsx